(function () {
  if (window.__shopAiCartSyncLoaded) return;
  window.__shopAiCartSyncLoaded = true;

  function refreshMotionCartDrawer() {
    document.dispatchEvent(new CustomEvent('cart:build'));
  }

  function findCartTrigger() {
    return (
      document.querySelector('[data-drawer-id="CartDrawer"]') ||
      document.querySelector('[aria-controls="CartDrawer"]') ||
      document.querySelector('button[name="cart"]') ||
      document.querySelector('a[href="/cart"]')
    );
  }

  function openMotionCartDrawer() {
    var cartTrigger = findCartTrigger();
    if (!cartTrigger) return;

    cartTrigger.click();
  }

  function refreshAndOpenMotionCartDrawer() {
    refreshMotionCartDrawer();

    window.setTimeout(function () {
      openMotionCartDrawer();
    }, 250);
  }

  document.addEventListener('shopai:cart-updated', function () {
    refreshAndOpenMotionCartDrawer();
  });

  window.ShopAICartSync = {
    refresh: refreshMotionCartDrawer,
    open: openMotionCartDrawer,
    refreshAndOpen: refreshAndOpenMotionCartDrawer,
  };
})();
